import React, { useCallback, useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import useFetch from '../../hooks/useFetch';
import MainLayout from '../../layouts/MainLayout';
import "../../styles/MyProfile.css";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faBriefcase, 
  faUsers, 
  faIdCard, 
  faSearch,
  faUserPlus,
  faCalendarCheck,
  faUserCircle,
  faUserTie,
  faUserShield,
  faMapMarkedAlt,
  faTasks,
  faShieldAlt,
  faIdBadge,
  faPhoneAlt
} from '@fortawesome/free-solid-svg-icons';

const AgriProfile = () => {
  const authState = useSelector(state => state.authReducer);
  const navigate = useNavigate();
  const [fetchData] = useFetch();
  const userId = authState.user._id;

  const [profileData, setProfileData] = useState({
    userId: userId,
    think5whysCode: authState.user.think5whyscode,
    name: authState.user.name,
    gender: '',  
    dob: null, 
    email: authState.user.email,
    mobile: '',
    referredBy: '',
    languageSpeaks: '',
    languageWrites: '',
    qualification: '',
    outlookDetails: '',  
    healthDetails: '',   
    bloodGroup: '',      
    address: '',
    city: '',
    state: '',
    country: '',
    pincode: '',
    
    emergencyContactName: '',      
    emergencyContactRelation: '',  
    emergencyContactEmail: '',     
    emergencyContactMobile: '',    

    jobTitle: '',        
    department: '',      
    currentCompany: '',  
    doJoining: null,       

    kycVerified: false,  
    kycVerifiedBy: null, 
    kycVerifiedDate: null, 
    poaDocType: '',        
    poaDocDetails: '',     
    poiDocType: '',        
    poiDocDetails: '',    
    
    policyNumber: '',  
    policyName: '',  
    policyType: 'Group',  
    sumInsured: '', 
    policyExpiryDate: null,
    insuranceCompany: '',
    insuranceTPA: '',
    insuranceDetails: '',  
    
    isSignature: false,      
    isBiometric: false,      
    biometricType: '',       

    blueCardIssuedBy: "Think5Whys Global DeepTech Solutions", 
    issueDate: null,     
    expiryDate: null,    
    specialRemarks: '', 

    isAvailable: true, 
    availableForWork: '',
    isAvailable: true,
    availabilityRemarks: '', 
    socialLinks: '',
    personalPageLink: '',
    bio: '',

    feedback: [], 

    isActive: true,    
    isDeleted: false,  
    createdBy: userId, 
    dateCreated: new Date(),  
    dateUpdated: new Date(),  
    otp: '', 
    otpExpires: null,  

    referredBy: '',
    minAmount: 0,
    maxAmount: 0,
    currency: 'Rs.',
    amtTenure: 'Monthly',
    isNegotiable: false,
    prefTiming: '',
    masterReference: '',
    overtimeChoice: 'No',
    myPreferredCategory: '',
    myPreferredLocation: '',
    myKeywords: '',

    currProject: "",
    currSite: "",
    currLocality: "",    
    currPlace: "",
    currPS: "",
    currHospitals: "",
    currLocalBody: "",
    currSubDistrict: "",
    currDistrict: "",
    currRegion: "",
    currState: "",
    currCountry: "",
    currPIN: "",

    handAggregatorCode: "",
    handAggregatorName: "",
    handAggregatorDate: null,
    handAggregatorRemarks: "",
    handMAggregatorCode: "",
    handMAggregatorName: "",
    handMAggregatorDate: null,
    handMAggregatorRemarks: "",

    handVerifierCode: "",
    handVerifierName: "",
    handVerifierDate: null,
    handVerifierSelfRemarks: "",
    handVerifierPvtRemarks: "",
    handVerifierPubRemarks: "",

    handContractorCode: "",
    handContractorName: "",
    handContractorDate: null,
    handContractorRemarks: "",

    handSubContractorCode: "",
    handSubContractorName: "",
    handSubContractorDate: null,
    handSubContractorRemarks: "",

    handMEmployerCode: "",
    handMEmployerName: "",
    handMEmployerDate: null,
    handMEmployerRemarks: "",

    handAdminCode: "",
    handAdminName: "",
    handAdminDate: null,
    handAdminRemarks: "",

    handSAdminCode: "",
    handSAdminName: "",
    handSAdminDate: null,
    handSAdminRemarks: "",
  });

  const [originalProfileData, setOriginalProfileData] = useState({});
  const [profileExists, setProfileExists] = useState(false);
  const [profileId, setProfileId] = useState('');
  const [loading, setLoading] = useState(true);
  const [createSuccess, setCreateSuccess] = useState(false);
  const [updateSuccess, setUpdateSuccess] = useState(false);
  const [createSuccessMsg, setCreateSuccessMsg] = useState('');
  const [updateSuccessMsg, setUpdateSuccessMsg] = useState('');
  const [creatingProfile, setCreatingProfile] = useState(false);
  const [errors, setErrors] = useState({});

  useEffect(() => {
    fetchUserProfile(userId);
  }, [userId]);

  const fetchUserProfile = useCallback(() => {
    try {
      const config = {
        url: "/blueprofile/byid",
        method: 'post',
        data: { userId: userId },
        headers: { Authorization: authState.token },
      };
      fetchData(config)
        .then(response => {
          if (response && response.status) {
            // console.log("profile exists ",response);
            setProfileExists(true);
            const { blueProfile } = response;
            setProfileId(blueProfile._id);
            setProfileData(blueProfile);
          } else {
            setCreateSuccessMsg("Sorry! Profile Not Found. Please retry.");
          }
        })
        .catch(() => {
          setCreateSuccessMsg("Sorry! Profile Not Found. Please retry.");
        });
    } catch {
      setCreateSuccessMsg("Sorry! Profile not found. Please retry.");
    }
  }, [userId, fetchData, setProfileExists]);

  const [basicDetailsClicked, setBasicDetailsClicked] = useState(false);
  const handleBasicDetails = () => {
    setBasicDetailsClicked(!basicDetailsClicked);
  }

  const [extendedDetailsClicked, setExtendedDetailsClicked] = useState(false);
  const handleExtendedDetails = () => {
    setExtendedDetailsClicked(!extendedDetailsClicked);
  }

  const [otherDetailsClicked, setOtherDetailsClicked] = useState(false);
  const handleOtherDetails = () => {
    setOtherDetailsClicked(!otherDetailsClicked);
  }

  const [availabilityDetailsClicked, setAvailabilityDetailsClicked] = useState(false);
  const handleAvailability = () => {
    setAvailabilityDetailsClicked(!availabilityDetailsClicked);
  }

  const [emergencyContactDetailsClicked, setEmergencyContactDetailsClicked] = useState(false);
  const handleEmergencyContactDetails = () => {
    setEmergencyContactDetailsClicked(!emergencyContactDetailsClicked);
  }

  const [currentWorkDetailsClicked, setCurrentWorkDetailsClicked] = useState(false);
  const handleCurrentWorkDetails = () => {
    setCurrentWorkDetailsClicked(!currentWorkDetailsClicked);
  }

  const [poapoiClicked, setPoapoiClicked] = useState(false);
  const handlePoapoiDetails = () => {
    setPoapoiClicked(!poapoiClicked);
  }

  const [insuranceDetailsClicked, setInsuranceDetailsClicked] = useState(false);
  const handleInsuranceDetails = () => {
    setInsuranceDetailsClicked(!insuranceDetailsClicked);
  }

  const [workPreferenceClicked, setWorkPreferenceClicked] = useState(false);
  const handleWorkPreferenceDetails = () => {
    setWorkPreferenceClicked(!workPreferenceClicked);
  }

  const [keywordDetailsClicked, setKeywordDetailsClicked] = useState(false);
  const handleKeywordDetails = () => {
    setKeywordDetailsClicked(!keywordDetailsClicked);
  }

  const [aggregatorsDetailsClicked, setAggregatorsDetailsClicked] = useState(false);
  const handleAggregatorsDetails = () => {
    setAggregatorsDetailsClicked(!aggregatorsDetailsClicked);
  }

  const [contractorsDetailsClicked, setContractorsDetailsClicked] = useState(false);
  const handleContractorsDetails = () => {
    setContractorsDetailsClicked(!contractorsDetailsClicked);
  }

  const [adminDetailsClicked, setAdminDetailsClicked] = useState(false);
  const handleAdminDetails = () => {
    setAdminDetailsClicked(!adminDetailsClicked);
  }
  
  const [currentSiteInfoClicked, setCurrentSiteInfoClicked] = useState(false);
  const handleCurrentSiteInfo = () => {
    setCurrentSiteInfoClicked(!currentSiteInfoClicked);
  }
  // const  = useCallback(() => {
  //   validateInputs();
  // }

  const handleProfileUpdate = useCallback(() => {
    validateInputs();
    const config = {
      url: `/blueprofile/updateprofile`,
      method: 'post',
      data: { profileData: profileData, userId: userId},
      headers: { Authorization: authState.token },
    };
    fetchData(config)
      .then(response => {
        if (response && response.status) {
          setOriginalProfileData(profileData);
          setUpdateSuccess(true);
          setUpdateSuccessMsg("Profile updated successfully!");
        } else {
          setUpdateSuccessMsg("Error updating profile! Please retry.");
        }
      })
      .catch(() => {
        setUpdateSuccessMsg("Error updating profile! Please retry.");
      });
  }, [profileData, profileId, fetchData]);

  const handleCancel = () => {
    setProfileData(originalProfileData);
  };

  const handleCreateProfile = () => {
    setCreatingProfile(true);
    fetchProfileCreate();
  };

  const fetchProfileCreate = useCallback(() => {
    const config = {
      url: "/blueprofile",
      method: 'post',
      data: profileData,
      headers: { Authorization: authState.token },
    };
    fetchData(config)
      .then(response => {
        if (response && response.status) {
          setCreateSuccess(true);
          setCreateSuccessMsg("Profile Created Successfully");
        } else {
          setCreateSuccessMsg("Sorry! Profile Not Created. Please retry.");
        }
      })
      .catch(() => {
        setCreateSuccessMsg("Sorry! Profile Not Created. Please retry.");
      });
  }, [profileData, fetchData]);

  const validateInputs = () => {
    let isValid = true;
    const errors = {};
    const mobileRegex = /^\d{10}$/;
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (profileData.gender === undefined || profileData.gender === null) {
      errors.gender = 'Gender is required.';
      isValid = false;
    }

    if (!profileData.dob) {
      errors.dob = 'Date of Birth is required.';
      isValid = false;
    }

    if (!emailRegex.test(profileData.email)) {
      setMessage("Please enter a valid email address.");
      isValid = false;
    }

    // if (!profileData.mobile) {
    //   errors.mobile = 'Mobile Number is required.';
    //   isValid = false;
    // } else if (!mobileRegex.test(profileData.mobile)) {
    //   errors.mobile = 'Mobile Number must be exactly 10 digits.';
    //   isValid = false;
    // }

    if (profileData.mobile && profileData.mobile.trim() !== '') {
      if (!mobileRegex.test(profileData.mobile)) {
        errors.mobile = 'Mobile Number must be exactly 10 digits and start with a digit other than 0.';
        isValid = false;
      }
    }

    if (!profileData.state) {
      errors.state = 'State is required.';
      isValid = false;
    }
    if (!profileData.city) {
      errors.city = 'City is required.';
      isValid = false;
    }
    if (!profileData.country) {
      errors.country = 'Country is required.';
      isValid = false;
    }
    if (!profileData.address) {
      errors.address = 'Address is required.';
      isValid = false;
    }
    if (!profileData.pincode) {
      errors.pincode = 'Pincode is required.';
      isValid = false;
    }
    if (profileData.myKeywords && profileData.myKeywords.length > 250) {
      errors.myKeywords = 'Max Keywords Length is 250 Characters!';
      isValid = false;
    }

    setErrors(errors);
    return isValid;
  };

  return (
    <MainLayout>
      <div className='text-lg mt-12 mb-2 mx-8'>
        <h2 className='text-2xl font-bold text-white text-center'>My Blue Profile</h2>
      </div>
      <div className='min-h-[50vh] mt-4 border border-b-gray-300 p-4 rounded-lg bg-gray-800 text-white'>
        {!profileExists && (
          <div className='flex justify-center items-center mt-4'>
            <button
              className='create-profile-button px-4 py-2 bg-blue-600 rounded-full text-white hover:bg-blue-700'
              onClick={handleCreateProfile}
              disabled={creatingProfile}
            >
              Initiate Your Blue Profile Creation
            </button>
          </div>
        )}
        
        {profileExists && (
          <>
            <div className='flex flex-col gap-4'>
              <div className='flex flex-col border border-purple-400 py-2 px-2'>
                <label className='text-yellow-200'>Name: {profileData.name}</label>
                {/* <input
                  className="profile-input bg-gray-600 rounded-md px-2 py-1"
                  type="text"
                  value={profileData.name}
                  disabled
                /> */}
              </div>

              <div className='border border-yellow-200 py-2 px-2 mt-2 flex flex-col'>
                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 p-2">
                  <button
                    className="w-full px-4 py-2 bg-green-600 text-white hover:bg-green-700 rounded-md"
                    onClick={handleBasicDetails}
                  >
                    <FontAwesomeIcon icon={faIdCard} className='mr-2'/>Basic Identity Details
                  </button>

                  <button
                    className="w-full px-4 py-2 bg-green-600 text-white hover:bg-green-700 rounded-md"
                    onClick={handleExtendedDetails}
                  >
                    <FontAwesomeIcon icon={faUserPlus} className='mr-2'/>Additional Bio
                  </button>

                  <button
                    className="w-full px-4 py-2 bg-green-600 text-white hover:bg-green-700 rounded-md"
                    onClick={handleOtherDetails}
                  >
                    <FontAwesomeIcon icon={faUsers} className='mr-2'/>Social & Other Details
                  </button>

                  <button
                    className="w-full px-4 py-2 bg-green-600 text-white hover:bg-green-700 rounded-md"
                    onClick={handleAvailability}
                  >
                    <FontAwesomeIcon icon={faCalendarCheck} className='mr-2'/>Availability
                  </button>

                </div>
                { basicDetailsClicked && (
                  <div className='border border-blue-400 px-2 py-2'>
                    <div className='flex flex-col'>
                      <label className='text-yellow-200'>User Code:</label>
                      <input
                        className="profile-input bg-gray-600 rounded-md px-2 py-1"
                        type="text"
                        style={{width: "250px"}}
                        value={profileData.think5whysCode}
                        disabled
                      />
                    </div>

                    <div className='flex flex-col'>
                      <label className='text-yellow-200'>Reference Code:</label>
                      <input
                        className="profile-input bg-gray-600 rounded-md px-2 py-1"
                        type="text"
                        style={{width: "250px"}}
                        value={profileData.referredBy}
                        onChange={(e) => setProfileData({ ...profileData, referredBy: e.target.value })}
                      />
                    </div>

                    <div className='flex flex-col'>
                      <label>Gender:</label>
                      <select
                        className="profile-select bg-gray-600 rounded-md px-2 py-1"
                        value={profileData.gender}
                        onChange={(e) => setProfileData({ ...profileData, gender: e.target.value })}
                      >
                        <option value={'Male'}>Male</option>
                        <option value={'Female'}>Female</option>
                        <option value={'Other'}>Other</option>
                      </select>
                      {errors.gender && <span className="text-red-500 text-xs">{errors.gender}</span>}
                    </div>

                    <div className='flex flex-col'>
                      <label>Date of Birth:</label>
                      <input
                        className="profile-date bg-gray-600 rounded-md px-2 py-1"
                        type="date"
                        value={profileData.dob ? profileData.dob.substring(0, 10) : ''}
                        onChange={(e) => setProfileData({ ...profileData, dob: e.target.value })}
                      />
                    </div>

                    <div className='flex flex-col'>
                      <label className='text-yellow-200'>Email:</label>
                      <input
                        className="profile-input bg-gray-600 rounded-md px-2 py-1"
                        type="email"
                        value={profileData.email}
                        disabled
                      />
                    </div>

                    <div className='flex flex-col'>
                      <label className='text-yellow-200'>Mobile Number:</label>
                      <input
                        className="profile-input bg-gray-600 rounded-md px-2 py-1"
                        type="tel"
                        value={profileData.mobile}
                        onChange={(e) => setProfileData({ ...profileData, mobile: e.target.value })}
                      />
                      {errors.mobile && <span className="text-red-500 text-xs">{errors.mobile}</span>}
                    </div>

                    <div className='flex flex-col'>
                      <label className='text-yellow-200'>City:</label>
                      <input
                        className="profile-input bg-gray-600 rounded-md px-2 py-1"
                        type="text"
                        value={profileData.city}
                        style={{width:'250px'}}
                        onChange={(e) => setProfileData({ ...profileData, city: e.target.value })}
                      />
                    </div>

                    <div className='flex flex-col'>
                      <label>State:</label>
                      <input
                        className="profile-input bg-gray-600 rounded-md px-2 py-1"
                        type="text"
                        value={profileData.state}
                        style={{width:'250px'}}
                        onChange={(e) => setProfileData({ ...profileData, state: e.target.value })}
                      />
                    </div>

                    <div className='flex flex-col'>
                      <label>Country:</label>
                      <input
                        className="profile-input bg-gray-600 rounded-md px-2 py-1"
                        type="text"
                        value={profileData.country}
                        style={{width:'250px'}}
                        onChange={(e) => setProfileData({ ...profileData, country: e.target.value })}
                      />
                    </div>

                    <div className='flex flex-col'>
                      <label>Postal Code:</label>
                      <input
                        className="profile-input bg-gray-600 rounded-md px-2 py-1"
                        type="text"
                        value={profileData.pincode}
                        style={{width:'200px'}}
                        onChange={(e) => setProfileData({ ...profileData, pincode: e.target.value })}
                      />
                    </div>

                    <div className='flex flex-col'>
                      <label>Address:</label>
                      <textarea
                        className="bg-gray-600 rounded-md px-2 py-1"
                        style={{width:'100%', height: '150px'}}
                        value={profileData.address}
                        onChange={(e) => setProfileData({ ...profileData, address: e.target.value })}
                      />
                    </div>
                  </div>
                )}
                { extendedDetailsClicked && (
                  <div className='flex flex-col border border-green-300 mt-2 py-2 px-2'>
                    <div className='flex flex-col'>
                      <label>Languages Speaks:</label>
                      <input
                        className="profile-input bg-gray-600 rounded-md px-2 py-1"
                        type="text"
                        value={profileData.languageSpeaks}
                        style={{width:'200px'}}
                        onChange={(e) => setProfileData({ ...profileData, languageSpeaks: e.target.value })}
                      />
                    </div>
                    <div className='flex flex-col'>
                      <label>Languages Writes:</label>
                      <input
                        className="profile-input bg-gray-600 rounded-md px-2 py-1"
                        type="text"
                        value={profileData.languageWrites}
                        style={{width:'200px'}}
                        onChange={(e) => setProfileData({ ...profileData, languageWrites: e.target.value })}
                      />
                    </div>
                    <div className='flex flex-col'>
                      <label>Qualification:</label>
                      <input
                        className="profile-input bg-gray-600 rounded-md px-2 py-1"
                        type="text"
                        value={profileData.qualification}
                        style={{width:'200px'}}
                        onChange={(e) => setProfileData({ ...profileData, qualification: e.target.value })}
                      />
                    </div>
                    <div className='flex flex-col  px-2 py-2'>
                      <label>About / Brief Bio:</label>
                      <textarea
                        className="bg-gray-600 rounded-md px-2 py-1"
                        style={{ border: '1px solid #ccc', maxWidth: '100%', maxHeight: '250px' }}
                        value={profileData.bio}
                        onChange={(e) => setProfileData({ ...profileData, bio: e.target.value })}
                      />
                    </div>
                  </div>
                )}
                { otherDetailsClicked && (
                  <div className='border border-red-300 py-2 px-2 mt-2'>
                    <div className='flex flex-col px-2 py-2'>
                      <label>Social / Personal Page Link:</label>
                      <input
                        className="profile-input bg-gray-600 rounded-md px-2 py-1"
                        type="text"
                        value={profileData.personalPageLink}
                        onChange={(e) => setProfileData({ ...profileData, personalPageLink: e.target.value })}
                      />
                    </div>
                    <div className='flex flex-col  px-2 py-2'>
                      <label>Outlook Details:</label>
                      <textarea
                        className="bg-gray-600 rounded-md px-2 py-1"
                        style={{ border: '1px solid #ccc', maxWidth: '100%', maxHeight: '150px' }}
                        value={profileData.outlookDetails}
                        onChange={(e) => setProfileData({ ...profileData, outlookDetails: e.target.value })}
                      />
                    </div>
                    <div className='flex flex-col  px-2 py-2'>
                        <label>Special Remarks:</label>
                        <textarea
                          className="bg-gray-600 rounded-md px-2 py-1"
                          style={{ border: '1px solid #ccc', maxWidth: '100%', maxHeight: '150px' }}
                          value={profileData.specialRemarks}
                          onChange={(e) => setProfileData({ ...profileData, specialRemarks: e.target.value })}
                        />
                      </div>
                  </div>
                )}
                { availabilityDetailsClicked && (
                  <div className='border border-white py-2 px-2 mt-2'>
                    <div className='flex flex-col  px-2 py-2'>
                      <div className="flex items-center gap-2">
                        <input 
                          type="checkbox" 
                          id="availability"
                          className="cursor-pointer accent-green-500"
                          checked={profileData.isAvailable} 
                          onChange={(e) => setProfileData({ ...profileData, isAvailable: e.target.checked })} 
                        />
                        <label htmlFor="availability" className="text-m font-semibold text-white">
                          I am available
                        </label>
                      </div>
                      <label>Work Available For:</label>
                      <textarea
                        className="bg-gray-600 rounded-md px-2 py-1"
                        style={{ border: '1px solid #ccc', maxWidth: '100%', maxHeight: '100px' }}
                        value={profileData.availableForWork}
                        onChange={(e) => setProfileData({ ...profileData, availableForWork: e.target.value })}
                      />
                      <label>Availability Remarks:</label>
                      <textarea
                        className="bg-gray-600 rounded-md px-2 py-1"
                        style={{ border: '1px solid #ccc', maxWidth: '100%', maxHeight: '150px' }}
                        value={profileData.availabilityRemarks}
                        onChange={(e) => setProfileData({ ...profileData, availabilityRemarks: e.target.value })}
                      />
                    </div>
                  </div>
                )}
              </div>

              <div className='border border-red-300 py-2 px-2 mt-2 flex flex-col'>
                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-3 gap-4 p-2">
                  <button
                    className="w-full px-4 py-2 bg-green-600 text-white hover:bg-green-700 rounded-md"
                    onClick={handleEmergencyContactDetails}
                  >
                    <FontAwesomeIcon icon={faPhoneAlt} className='mr-2 text-red-600'/>Emergency Contact Details
                  </button>

                  <button
                    className="w-full px-4 py-2 bg-green-600 text-white hover:bg-green-700 rounded-md"
                    onClick={handlePoapoiDetails}
                  >
                    <FontAwesomeIcon icon={faIdBadge} className='mr-2 text-blue-600'/>Identity & Address Proof
                  </button>

                  <button
                    className="w-full px-4 py-2 bg-green-600 text-white hover:bg-green-700 rounded-md"
                    onClick={handleInsuranceDetails}
                  >
                    <FontAwesomeIcon icon={faShieldAlt} className='mr-2 text-green-200'/>Insurance Details
                  </button>

                  <button
                    className="w-full px-4 py-2 bg-green-600 text-white hover:bg-green-700 rounded-md"
                    onClick={handleCurrentWorkDetails}
                  >
                    <FontAwesomeIcon icon={faBriefcase} className='mr-2 text-yellow-200'/>Current Work Details
                  </button>

                  <button
                      className='update-profile-button px-2 py-2 bg-green-600 text-white hover:bg-green-700 mr-4'
                      onClick={handleWorkPreferenceDetails}
                    >
                      <FontAwesomeIcon icon={faTasks} className='mr-2 text-orange-400'/>Work Preference Details
                  </button>

                  <button
                      className='update-profile-button px-2 py-2 bg-green-600 text-white hover:bg-green-700 mr-4'
                      onClick={handleKeywordDetails}
                    >
                      <FontAwesomeIcon icon={faSearch} className='mr-2 text-white'/>My Search Keyword
                  </button>
                </div>

                { emergencyContactDetailsClicked && (
                  <div className='border border-green-200 py-2 px-2'>
                    <div className='flex flex-col'>
                      <label className='text-yellow-200'>Emergency Contact Name:</label>
                      <input
                        className="profile-input bg-gray-600 rounded-md px-2 py-1"
                        type="text"
                        value={profileData.emergencyContactName}
                        onChange={(e) => setProfileData({ ...profileData, emergencyContactName: e.target.value })}
                      />
                    </div>

                    <div className='flex flex-col'>
                      <label>Emergency Contact Relation:</label>
                      <input
                        className="profile-input bg-gray-600 rounded-md px-2 py-1"
                        type="text"
                        value={profileData.emergencyContactRelation}
                        style={{ width: '250px' }}
                        onChange={(e) => setProfileData({ ...profileData, emergencyContactRelation: e.target.value })}
                      />
                    </div>

                    <div className='flex flex-col'>
                      <label>Emergency Contact Email:</label>
                      <input
                        className="profile-input bg-gray-600 rounded-md px-2 py-1"
                        type="email"
                        value={profileData.emergencyContactEmail}
                        onChange={(e) => setProfileData({ ...profileData, emergencyContactEmail: e.target.value })}
                      />
                    </div>

                    <div className='flex flex-col'>
                      <label>Emergency Contact Mobile:</label>
                      <input
                        className="profile-input bg-gray-600 rounded-md px-2 py-1"
                        type="tel"
                        value={profileData.emergencyContactMobile}
                        onChange={(e) => setProfileData({ ...profileData, emergencyContactMobile: e.target.value })}
                      />
                    </div>
                  </div>
                )}
                { currentWorkDetailsClicked && (
                  <div className='border border-yellow-200 py-2 px-2 mt-2 flex flex-col'>
                    <div className='flex flex-col'>
                      <label>Job Title:</label>
                      <input
                        className="profile-input bg-gray-600 rounded-md px-2 py-1"
                        type="text"
                        value={profileData.jobTitle}
                        onChange={(e) => setProfileData({ ...profileData, jobTitle: e.target.value })}
                      />
                    </div>

                    <div className='flex flex-col'>
                      <label>Department:</label>
                      <input
                        className="profile-input bg-gray-600 rounded-md px-2 py-1"
                        type="text"
                        value={profileData.department}
                        onChange={(e) => setProfileData({ ...profileData, department: e.target.value })}
                      />
                    </div>

                    <div className='flex flex-col'>
                      <label>Current Company:</label>
                      <input
                        className="profile-input bg-gray-600 rounded-md px-2 py-1"
                        type="text"
                        value={profileData.currentCompany}
                        onChange={(e) => setProfileData({ ...profileData, currentCompany: e.target.value })}
                      />
                    </div>

                    <div className='flex flex-col'>
                      <label>Date of Joining:</label>
                      <input
                        className="profile-date bg-gray-600 rounded-md px-2 py-1"
                        type="date"
                        value={profileData.doJoining ? profileData.doJoining.substring(0, 10) : ''}
                        onChange={(e) => setProfileData({ ...profileData, doJoining: e.target.value })}
                      />
                    </div>
                </div>
                )}
                { poapoiClicked && (
                  <div className='flex flex-col  border border-green-500 py-2 px-2'>
                    <div className='flex flex-col'>
                      <label>Proof of Address Document Type:</label>
                      <input
                        className="profile-input bg-gray-600 rounded-md px-2 py-1"
                        type="text"
                        value={profileData.poaDocType}
                        style={{ width: '300px' }}
                        onChange={(e) => setProfileData({ ...profileData, poaDocType: e.target.value })}
                      />
                    </div>

                    <div className='flex flex-col'>
                      <label>Proof of Address Document Details:</label>
                      <textarea
                        className="bg-gray-600 rounded-md px-2 py-1"
                        style={{ border: '1px solid #ccc', maxWidth: '100%', maxHeight: '150px' }}
                        value={profileData.poaDocDetails}
                        onChange={(e) => setProfileData({ ...profileData, poaDocDetails: e.target.value })}
                      />
                    </div>

                    <div className='flex flex-col'>
                      <label>Proof of Identity Document Type:</label>
                      <input
                        className="profile-input bg-gray-600 rounded-md px-2 py-1"
                        type="text"
                        value={profileData.poiDocType}
                        style={{ width: '300px' }}
                        onChange={(e) => setProfileData({ ...profileData, poiDocType: e.target.value })}
                      />
                    </div>

                    <div className='flex flex-col'>
                      <label>Proof of Identity Document Details:</label>
                      <textarea
                        className="bg-gray-600 rounded-md px-2 py-1"
                        style={{ border: '1px solid #ccc', maxWidth: '100%', maxHeight: '150px' }}
                        value={profileData.poiDocDetails}
                        onChange={(e) => setProfileData({ ...profileData, poiDocDetails: e.target.value })}
                      />
                    </div>

                    <div className='flex flex-col'>
                      <label>Health Details:</label>
                      <textarea
                        className="bg-gray-600 rounded-md px-2 py-1"
                        style={{ border: '1px solid #ccc', maxWidth: '100%', maxHeight: '150px' }}
                        value={profileData.healthDetails}
                        onChange={(e) => setProfileData({ ...profileData, healthDetails: e.target.value })}
                      />
                    </div>

                    <div className='flex flex-col'>
                      <label>Blood Group:</label>
                      <input
                        className="profile-input bg-gray-600 rounded-md px-2 py-1"
                        type="text"
                        value={profileData.bloodGroup}
                        style={{ width: '100px' }}
                        onChange={(e) => setProfileData({ ...profileData, bloodGroup: e.target.value })}
                      />
                    </div>
                </div>
              )}
              {/* Insurance Details */}
              { insuranceDetailsClicked && (
                <div className='flex flex-col mt-4 border border-red-500 py-2 px-2'>
                  <label className='text-yellow-200 text-lg'>Insurance Details:</label>
                  <label>Policy Number:</label>
                  <input
                    className="profile-input bg-gray-600 rounded-md px-2 py-1"
                    type="text"
                    value={profileData.policyNumber}
                    style={{ width: '250px' }}
                    onChange={(e) => setProfileData({ ...profileData, policyNumber: e.target.value })}
                  />
                  <label>Policy Name:</label>
                  <input
                    className="profile-input bg-gray-600 rounded-md px-2 py-1"
                    type="text"
                    value={profileData.policyName}
                    style={{ width: '250px' }}
                    onChange={(e) => setProfileData({ ...profileData, policyName: e.target.value })}
                  />
                  <label>Policy Type:</label>
                  <input
                    className="profile-input bg-gray-600 rounded-md px-2 py-1"
                    type="text"
                    value={profileData.policyType}
                    style={{ width: '250px' }}
                    onChange={(e) => setProfileData({ ...profileData, policyType: e.target.value })}
                  />
                  <label>Sum Insured:</label>
                  <input
                    className="profile-input bg-gray-600 rounded-md px-2 py-1"
                    type="text"
                    value={profileData.sumInsured}
                    style={{ width: '250px' }}
                    onChange={(e) => setProfileData({ ...profileData, sumInsured: e.target.value })}
                  />
                  <label>Policy Expiry Date:</label>
                  <input
                    className="profile-date bg-gray-600 rounded-md px-2 py-1"
                    type="date"
                    value={profileData.policyExpiryDate ? profileData.policyExpiryDate.substring(0, 10) : ''}
                    onChange={(e) => setProfileData({ ...profileData, policyExpiryDate: e.target.value })}
                  />
                  <label>Insurance Company:</label>
                  <input
                    className="profile-input bg-gray-600 rounded-md px-2 py-1"
                    type="text"
                    value={profileData.insuranceCompany}
                    style={{ width: '400px' }}
                    onChange={(e) => setProfileData({ ...profileData, insuranceCompany: e.target.value })}
                  />
                  <label>TPA:</label>
                  <input
                    className="profile-input bg-gray-600 rounded-md px-2 py-1"
                    type="text"
                    value={profileData.insuranceTPA}
                    style={{ width: '400px' }}
                    onChange={(e) => setProfileData({ ...profileData, insuranceTPA: e.target.value })}
                  />
                  <label>Remarks:</label>
                  <textarea
                    className="bg-gray-600 rounded-md px-2 py-1"
                    style={{ border: '1px solid #ccc', maxWidth: '100%', maxHeight: '150px' }}
                    value={profileData.insuranceDetails}
                    onChange={(e) => setProfileData({ ...profileData, insuranceDetails: e.target.value })}
                  />
                </div>
              )}
              {workPreferenceClicked && (
              <div className='flex flex-col border border-white px-2 py-2'>
                <div className='flex flex-col'>
                  <p className='text-yellow-200 text-lg'>Work Preference Remarks:</p>
                </div>
                <div className='flex flex-col'>
                  <label>Minimum  Salary/Wages Expectation:</label>
                  <input
                    className="profile-input bg-gray-600 rounded-md px-2 py-1"
                    type="text"
                    value={profileData.minAmount}
                    style={{ width: '150px' }}
                    onChange={(e) => setProfileData({ ...profileData, minAmount: e.target.value })}
                  />
                </div>
                <div className='flex flex-col'>
                  <label>Maximum Salary/Wages Expectation:</label>
                  <input
                    className="profile-input bg-gray-600 rounded-md px-2 py-1"
                    type="text"
                    value={profileData.maxAmount}
                    style={{ width: '150px' }}
                    onChange={(e) => setProfileData({ ...profileData, maxAmount: e.target.value })}
                  />
                </div>
                <div className='flex flex-col'>
                  <label>Currency:</label>
                  <input
                    className="profile-input bg-gray-600 rounded-md px-2 py-1"
                    type="text"
                    value={profileData.currency}
                    style={{ width: '50px' }}
                    onChange={(e) => setProfileData({ ...profileData, currency: e.target.value })}
                  />
                </div>
                <div className='flex flex-col'>
                  <label> Salary/Wages Expectation Period:</label>
                  <input
                    className="profile-input bg-gray-600 rounded-md px-2 py-1"
                    type="text"
                    value={profileData.amtTenure}
                    style={{ width: '200px' }}
                    onChange={(e) => setProfileData({ ...profileData, amtTenure: e.target.value })}
                  />
                </div>
                <div className='flex flex-col'>
                  <label>Working Time Preference & Time Zone:</label>
                  <input
                    className="profile-input bg-gray-600 rounded-md px-2 py-1"
                    type="text"
                    value={profileData.prefTiming}
                    style={{ width: '300px' }}
                    onChange={(e) => setProfileData({ ...profileData, prefTiming: e.target.value })}
                  />
                </div>
                <div className='flex flex-col'>
                    <label>Overtime Choice:</label>
                    <select
                      className="profile-select bg-gray-600 rounded-md px-2 py-1"
                      style={{ width: '300px' }}
                      value={profileData.overtimeChoice}
                      onChange={(e) => setProfileData({ ...profileData, overtimeChoice: e.target.value })}
                    >
                      <option value="Yes - Max 2 Hrs">Yes - Max 2 Hrs</option>
                      <option value="Yes - Max 4 Hrs">Yes - Max 4 Hrs</option>
                      <option value="No">Not Interested in Overtime</option>
                    </select>
                  </div>
                  <div className='flex flex-col'>
                    <label>Preferred Job Location:</label>
                    <input
                      className="profile-input bg-gray-600 rounded-md px-2 py-1"
                      type="text"
                      value={profileData.myPreferredLocation}
                      style={{ width: '300px' }}
                      onChange={(e) => setProfileData({ ...profileData, myPreferredLocation: e.target.value })}
                    />
                  </div>
                  <div className='flex flex-col'>
                    <label>Prferred Category:</label>
                    <select
                      value={profileData.myPreferredCategory}
                      onChange={(e) => setProfileData({ ...profileData, myPreferredCategory: e.target.value })}
                      className="border border-gray-300 bg-gray-600  rounded-md px-4 py-2 w-full md:w-auto focus:outline-none focus:ring-2 focus:ring-blue-500"
                      style={{ border: '1px solid #ccc', padding: '8px', height: '36px', width: '200px' }}
                    >
                      <option value="Blue Collar">Highly Skilled</option>
                      <option value="Labour">Labour</option>
                      <option value="Contractor">Contractor</option>
                      <option value="Consultant">Consultant</option>
                      <option value="Company">Jobs</option>
                      <option value="Supervisor">Supervisor</option>
                    </select>
                  </div>
                </div>
              )}
              { keywordDetailsClicked && (
                <div className='border border-green-300 py-2 px-2 flex flex-col mb-2 mt-2'>
                  <label>My Keywords(Max 5):</label>
                  <input
                    className="profile-input bg-gray-600 rounded-md px-2 py-1"
                    type="text"
                    value={profileData.myKeywords}
                    style={{ width: '100%' }}
                    onChange={(e) => setProfileData({ ...profileData, myKeywords: e.target.value })}
                  />
                  {errors.myKeywords && <span className="text-red-500 text-xs">{errors.myKeywords}</span>}
                </div>
              )}
            </div>
          </div>
          <div className='flex flex-col border border-white py-2 px-2 mt-2'>
              <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-2 p-2 ">
                <button
                  className='update-profile-button px-2 py-2 bg-green-600 text-white hover:bg-green-700 mr-4'
                  onClick={handleAggregatorsDetails}
                >
                  <FontAwesomeIcon icon={faUserCircle} className='mr-2'/>Aggregators Info
                </button>
                <button
                  className='update-profile-button px-2 py-2 bg-green-600 text-white hover:bg-green-700 mr-4'
                  onClick={handleContractorsDetails}
                >
                  <FontAwesomeIcon icon={faUserTie} className='mr-2'/>Contractors Info
                </button>
                <button
                  className='update-profile-button px-2 py-2 bg-green-600 text-white hover:bg-green-700 mr-4'
                  onClick={handleAdminDetails}
                >
                  <FontAwesomeIcon icon={faUserShield} className='mr-2'/>Admin Info
                </button>
                <button
                  className='update-profile-button px-2 py-2 bg-green-600 text-white hover:bg-green-700'
                  onClick={handleCurrentSiteInfo}
                >
                  <FontAwesomeIcon icon={faMapMarkedAlt} className='mr-2'/>Current Work Location Info
                </button>
              </div>
              {aggregatorsDetailsClicked && (
                <div className='border border-white py-2 px-2 mt-2'>
                  <p className='text-yellow-200 text-lg'>Aggregators</p>
                  <div className="flex flex-col text-lg mt-2">
                    <label>Aggregator Details:</label>
                    <label>Aggregator Code:</label>
                    <input
                      className="profile-input bg-gray-600 rounded-md px-2 py-1"
                      type="text"
                      value={profileData.handAggregatorCode}
                      style={{ width: '300px' }}
                      onChange={(e) => setProfileData({ ...profileData, handAggregatorCode: e.target.value })}
                    />
                    <label>Aggregator Name:</label>
                    <input
                      className="profile-input bg-gray-600 rounded-md px-2 py-1"
                      type="text"
                      value={profileData.handAggregatorName}
                      style={{ width: '300px' }}
                      onChange={(e) => setProfileData({ ...profileData, handAggregatorName: e.target.value })}
                    />
                    <label>Date:</label>
                    <input
                      className="profile-date bg-gray-600 rounded-md px-2 py-1"
                      type="date"
                      value={profileData.handAggregatorDate ? profileData.handAggregatorDate.substring(0, 10) : ''}
                      onChange={(e) => setProfileData({ ...profileData, handAggregatorDate: e.target.value })}
                    />
                    <label>Remarks:</label>
                    <textarea
                      className="bg-gray-600 rounded-md px-2 py-1"
                      style={{width:'100%', height: '150px'}}
                      value={profileData.handAggregatorRemarks}
                      onChange={(e) => setProfileData({ ...profileData, handAggregatorRemarks: e.target.value })}
                    />
                  </div>
                  <div className="flex flex-col text-lg mt-4">
                    <label>Master Aggregator Details:</label>
                    <label>Master Aggregator Code:</label>
                    <input
                      className="profile-input bg-gray-600 rounded-md px-2 py-1"
                      type="text"
                      value={profileData.handMAggregatorCode}
                      style={{ width: '300px' }}
                      onChange={(e) => setProfileData({ ...profileData, handMAggregatorCode: e.target.value })}
                    />
                    <label>Master Aggregator Name:</label>
                    <input
                      className="profile-input bg-gray-600 rounded-md px-2 py-1"
                      type="text"
                      value={profileData.handMAggregatorName}
                      style={{ width: '300px' }}
                      onChange={(e) => setProfileData({ ...profileData, handMAggregatorName: e.target.value })}
                    />
                    <label>Date:</label>
                    <input
                      className="profile-date bg-gray-600 rounded-md px-2 py-1"
                      type="date"
                      value={profileData.handMAggregatorDate ? profileData.handMAggregatorDate.substring(0, 10) : ''}
                      onChange={(e) => setProfileData({ ...profileData, handMAggregatorDate: e.target.value })}
                    />
                    <label>Remarks:</label>
                    <textarea
                      className="bg-gray-600 rounded-md px-2 py-1"
                      style={{width:'100%', height: '150px'}}
                      value={profileData.handMAggregatorRemarks}
                      onChange={(e) => setProfileData({ ...profileData, handMAggregatorRemarks: e.target.value })}
                    />
                  </div>
                </div>
              )}
              {contractorsDetailsClicked && (
                <div className='border border-white py-2 px-2 mt-2'>
                  <p className='text-yellow-200 text-lg'>Contractors</p>
                  <div className="flex flex-col text-lg mt-4">
                    <label>Contractor Details:</label>
                    <label>Contractor Code:</label>
                    <input
                      className="profile-input bg-gray-600 rounded-md px-2 py-1"
                      type="text"
                      value={profileData.handContractorCode}
                      style={{ width: '300px' }}
                      onChange={(e) => setProfileData({ ...profileData, handContractorCode: e.target.value })}
                    />
                    <label>Contractor Name:</label>
                    <input
                      className="profile-input bg-gray-600 rounded-md px-2 py-1"
                      type="text"
                      value={profileData.handContractorName}
                      style={{ width: '300px' }}
                      onChange={(e) => setProfileData({ ...profileData, handContractorName: e.target.value })}
                    />
                    <label>Date:</label>
                    <input
                      className="profile-date bg-gray-600 rounded-md px-2 py-1"
                      type="date"
                      value={profileData.handSubContractorDate ? profileData.handContractorDate.substring(0, 10) : ''}
                      onChange={(e) => setProfileData({ ...profileData, handContractorDate: e.target.value })}
                    />
                    <label>Remarks:</label>
                    <textarea
                      className="bg-gray-600 rounded-md px-2 py-1"
                      style={{width:'100%', height: '150px'}}
                      value={profileData.handContractorRemarks}
                      onChange={(e) => setProfileData({ ...profileData, handContractorRemarks: e.target.value })}
                    />
                  </div>
                  <div className="flex flex-col text-lg mt-4">
                    <label>Sub Contractor Details:</label>
                    <label>Sub Contractor Code:</label>
                    <input
                      className="profile-input bg-gray-600 rounded-md px-2 py-1"
                      type="text"
                      value={profileData.handSubContractorCode}
                      style={{ width: '300px' }}
                      onChange={(e) => setProfileData({ ...profileData, handSubContractorCode: e.target.value })}
                    />
                    <label>Sub Contractor Name:</label>
                    <input
                      className="profile-input bg-gray-600 rounded-md px-2 py-1"
                      type="text"
                      value={profileData.handSubContractorName}
                      style={{ width: '300px' }}
                      onChange={(e) => setProfileData({ ...profileData, handSubContractorName: e.target.value })}
                    />
                    <label>Date:</label>
                    <input
                      className="profile-date bg-gray-600 rounded-md px-2 py-1"
                      type="date"
                      value={profileData.handSubContractorDate ? profileData.handSubContractorDate.substring(0, 10) : ''}
                      onChange={(e) => setProfileData({ ...profileData, handSubContractorDate: e.target.value })}
                    />
                    <label>Remarks:</label>
                    <textarea
                      className="bg-gray-600 rounded-md px-2 py-1"
                      style={{width:'100%', height: '150px'}}
                      value={profileData.handSubContractorRemarks}
                      onChange={(e) => setProfileData({ ...profileData, handSubContractorRemarks: e.target.value })}
                    />
                  </div>
                  <div className="flex flex-col text-lg mt-4">
                    <label>Principal Employer Details:</label>
                    <label>Principal Employer Code:</label>
                    <input
                      className="profile-input bg-gray-600 rounded-md px-2 py-1"
                      type="text"
                      value={profileData.handMEmployerCode}
                      style={{ width: '300px' }}
                      onChange={(e) => setProfileData({ ...profileData, handMEmployerCode: e.target.value })}
                    />
                    <label>Principal Employer Name:</label>
                    <input
                      className="profile-input bg-gray-600 rounded-md px-2 py-1"
                      type="text"
                      value={profileData.handMEmployerName}
                      style={{ width: '300px' }}
                      onChange={(e) => setProfileData({ ...profileData, handMEmployerName: e.target.value })}
                    />
                    <label>Date:</label>
                    <input
                      className="profile-date bg-gray-600 rounded-md px-2 py-1"
                      type="date"
                      value={profileData.handMEmployerDate ? profileData.handMEmployerDate.substring(0, 10) : ''}
                      onChange={(e) => setProfileData({ ...profileData, handMEmployerDate: e.target.value })}
                    />
                    <label>Remarks:</label>
                    <textarea
                      className="bg-gray-600 rounded-md px-2 py-1"
                      style={{width:'100%', height: '150px'}}
                      value={profileData.handMEmployerRemarks}
                      onChange={(e) => setProfileData({ ...profileData, handMEmployerRemarks: e.target.value })}
                    />
                  </div>
                </div>
              )}
              {adminDetailsClicked && (
                <div className='border border-white py-2 px-2 mt-2'>
                  <p className='text-yellow-200 text-lg'>Administrators</p>
                  <div className="flex flex-col text-lg mt-4">
                    <label>Verifier Details:</label>
                    <label>Verifier Code:</label>
                    <input
                      className="profile-input bg-gray-600 rounded-md px-2 py-1"
                      type="text"
                      value={profileData.handVerifierCode}
                      style={{ width: '300px' }}
                      onChange={(e) => setProfileData({ ...profileData, handVerifierCode: e.target.value })}
                    />
                    <label>Verifier Name:</label>
                    <input
                      className="profile-input bg-gray-600 rounded-md px-2 py-1"
                      type="text"
                      value={profileData.handVerifierName}
                      style={{ width: '300px' }}
                      onChange={(e) => setProfileData({ ...profileData, handVerifierName: e.target.value })}
                    />
                    <label>Date:</label>
                    <input
                      className="profile-date bg-gray-600 rounded-md px-2 py-1"
                      type="date"
                      value={profileData.handVerifierDate ? profileData.handVerifierDate.substring(0, 10) : ''}
                      onChange={(e) => setProfileData({ ...profileData, handVerifierDate: e.target.value })}
                    />
                    <label>Own Memo:</label>
                    <textarea
                      className="bg-gray-600 rounded-md px-2 py-1"
                      style={{width:'100%', height: '150px'}}
                      value={profileData.handVerifierSelfRemarks}
                      onChange={(e) => setProfileData({ ...profileData, handVerifierSelfRemarks: e.target.value })}
                    />
                    <label>Remarks for BlueHand:</label>
                    <textarea
                      className="bg-gray-600 rounded-md px-2 py-1"
                      style={{width:'100%', height: '150px'}}
                      value={profileData.handVerifierPvtRemarks}
                      onChange={(e) => setProfileData({ ...profileData, handVerifierPvtRemarks: e.target.value })}
                    />
                    <label>Public Remarks:</label>
                    <textarea
                      className="bg-gray-600 rounded-md px-2 py-1"
                      style={{width:'100%', height: '150px'}}
                      value={profileData.handVerifierPubRemarks}
                      onChange={(e) => setProfileData({ ...profileData, handVerifierPubRemarks: e.target.value })}
                    />
                  </div>
                  <div className="flex flex-col text-lg mt-4">
                    <label>Admin Details:</label>
                    <label>Admin Code:</label>
                    <input
                      className="profile-input bg-gray-600 rounded-md px-2 py-1"
                      type="text"
                      value={profileData.handAdminCode}
                      style={{ width: '300px' }}
                      onChange={(e) => setProfileData({ ...profileData, handAdminCode: e.target.value })}
                    />
                    <label>Admin Name:</label>
                    <input
                      className="profile-input bg-gray-600 rounded-md px-2 py-1"
                      type="text"
                      value={profileData.handAdminName}
                      style={{ width: '300px' }}
                      onChange={(e) => setProfileData({ ...profileData, handAdminName: e.target.value })}
                    />
                    <label>Date:</label>
                    <input
                      className="profile-date bg-gray-600 rounded-md px-2 py-1"
                      type="date"
                      value={profileData.handAdminDate ? profileData.handAdminDate.substring(0, 10) : ''}
                      onChange={(e) => setProfileData({ ...profileData, handAdminDate: e.target.value })}
                    />
                    <label>Remarks:</label>
                    <textarea
                      className="bg-gray-600 rounded-md px-2 py-1"
                      style={{width:'100%', height: '150px'}}
                      value={profileData.handAdminRemarks}
                      onChange={(e) => setProfileData({ ...profileData, handAdminRemarks: e.target.value })}
                    />
                  </div>
                  <div className="flex flex-col text-lg mt-4">
                    <label>Super Admin Details:</label>
                    <label>Super Admin Code:</label>
                    <input
                      className="profile-input bg-gray-600 rounded-md px-2 py-1"
                      type="text"
                      value={profileData.handSAdminCode}
                      style={{ width: '300px' }}
                      onChange={(e) => setProfileData({ ...profileData, handSAdminCode: e.target.value })}
                    />
                    <label>Super Admin Name:</label>
                    <input
                      className="profile-input bg-gray-600 rounded-md px-2 py-1"
                      type="text"
                      value={profileData.handSAdminName}
                      style={{ width: '300px' }}
                      onChange={(e) => setProfileData({ ...profileData, handSAdminName: e.target.value })}
                    />
                    <label>Date:</label>
                    <input
                      className="profile-date bg-gray-600 rounded-md px-2 py-1"
                      type="date"
                      value={profileData.handSAdminDate ? profileData.handSAdminDate.substring(0, 10) : ''}
                      onChange={(e) => setProfileData({ ...profileData, handSAdminDate: e.target.value })}
                    />
                    <label>Remarks:</label>
                    <textarea
                      className="bg-gray-600 rounded-md px-2 py-1"
                      style={{width:'100%', height: '150px'}}
                      value={profileData.handSAdminRemarks}
                      onChange={(e) => setProfileData({ ...profileData, handSAdminRemarks: e.target.value })}
                    />
                  </div>
                </div>
              )}     
              {currentSiteInfoClicked && (
              <div className='flex flex-col border border-white py-2 px-2 mt-2'>
                <p className='text-yellow-200 text-lg'>Current Work Location:</p>
                <label>Project:</label>
                <input
                  className="profile-input bg-gray-600 rounded-md px-2 py-1"
                  type="text"
                  value={profileData.currProject}
                  style={{ width: '300px' }}
                  onChange={(e) => setProfileData({ ...profileData, currProject: e.target.value })}
                />
                <label>Site/Factory:</label>
                <input
                  className="profile-input bg-gray-600 rounded-md px-2 py-1"
                  type="text"
                  value={profileData.currSite}
                  style={{ width: '300px' }}
                  onChange={(e) => setProfileData({ ...profileData, currSite: e.target.value })}
                />
                <label>Locality:</label>
                <input
                  className="profile-input bg-gray-600 rounded-md px-2 py-1"
                  type="text"
                  value={profileData.currLocality}
                  style={{ width: '300px' }}
                  onChange={(e) => setProfileData({ ...profileData, currLocality: e.target.value })}
                />
                <label>City/Village:</label>
                <input
                  className="profile-input bg-gray-600 rounded-md px-2 py-1"
                  type="text"
                  value={profileData.currPlace}
                  style={{ width: '300px' }}
                  onChange={(e) => setProfileData({ ...profileData, currPlace: e.target.value })}
                />
                <label>Nearest Police Station:</label>
                <input
                  className="profile-input bg-gray-600 rounded-md px-2 py-1"
                  type="text"
                  value={profileData.currPS}
                  style={{ width: '300px' }}
                  onChange={(e) => setProfileData({ ...profileData, currPS: e.target.value })}
                />
                <label>Nearest Hospitals:</label>
                <input
                  className="profile-input bg-gray-600 rounded-md px-2 py-1"
                  type="text"
                  value={profileData.currHospitals}
                  style={{ width: '300px' }}
                  onChange={(e) => setProfileData({ ...profileData, currHospitals: e.target.value })}
                />
                <label>Local Body Name:</label>
                <input
                  className="profile-input bg-gray-600 rounded-md px-2 py-1"
                  type="text"
                  value={profileData.currLocalBody}
                  style={{ width: '300px' }}
                  onChange={(e) => setProfileData({ ...profileData, currLocalBody: e.target.value })}
                />
                <label>Sub-District:</label>
                <input
                  className="profile-input bg-gray-600 rounded-md px-2 py-1"
                  type="text"
                  value={profileData.currSubDistrict}
                  style={{ width: '300px' }}
                  onChange={(e) => setProfileData({ ...profileData, currSubDistrict: e.target.value })}
                />
                <label>District:</label>
                <input
                  className="profile-input bg-gray-600 rounded-md px-2 py-1"
                  type="text"
                  value={profileData.currDistrict}
                  style={{ width: '300px' }}
                  onChange={(e) => setProfileData({ ...profileData, currDistrict: e.target.value })}
                />
                <label>Region:</label>
                <input
                  className="profile-input bg-gray-600 rounded-md px-2 py-1"
                  type="text"
                  value={profileData.currRegion}
                  style={{ width: '300px' }}
                  onChange={(e) => setProfileData({ ...profileData, currRegion: e.target.value })}
                />
                <label>State:</label>
                <input
                  className="profile-input bg-gray-600 rounded-md px-2 py-1"
                  type="text"
                  value={profileData.currState}
                  style={{ width: '300px' }}
                  onChange={(e) => setProfileData({ ...profileData, currState: e.target.value })}
                />
                <label>Country:</label>
                <input
                  className="profile-input bg-gray-600 rounded-md px-2 py-1"
                  type="text"
                  value={profileData.currCountry}
                  style={{ width: '300px' }}
                  onChange={(e) => setProfileData({ ...profileData, currCountry: e.target.value })}
                />
                <label>Postal Code/PIN:</label>
                <input
                  className="profile-input bg-gray-600 rounded-md px-2 py-1"
                  type="text"
                  value={profileData.currPIN}
                  style={{ width: '300px' }}
                  onChange={(e) => setProfileData({ ...profileData, currPIN: e.target.value })}
                />
              </div>
            )}
          </div>
            {updateSuccess && (
              <div className="success-message text-green-500 text-lg mt-4">
                {updateSuccessMsg}
              </div>
            )}
            <div className='flex justify-center mt-6'>
              <button
                className='update-profile-button px-4 py-2 bg-green-600 text-white hover:bg-green-700 w-40 mr-4'
                onClick={handleProfileUpdate}
              >
                Update
              </button>
              <button
                className='update-profile-button px-4 py-2 bg-red-600 text-white hover:bg-red-700 w-40'
                onClick={() => navigate(-1)}
              >
                Back
              </button>
            </div>
          </>
        )}

        {!profileExists && createSuccess && (
          <div className="flex flex-col justify-center success-message text-green-500 text-xl mt-4">
            {createSuccessMsg}
            <button
                className='update-profile-button px-4 py-2 bg-red-600 rounded-full text-white hover:bg-red-700 w-40'
                onClick={() => navigate("/my-profile-home")}
              >
                OK
            </button>
          </div>
        )}
     </div>
    </MainLayout>
  );
};

export default AgriProfile;



